/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vekn_Add_To_CalendarInputs */



/**
* | output |
* | --- |
* | "Add to the VEKN calendar" |
*
* @param {Vekn_Add_To_CalendarInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const vekn_add_to_calendar = /** @type {((inputs?: Vekn_Add_To_CalendarInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vekn_Add_To_CalendarInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ajouter au calendrier VEKN")
	if (locale === "es") return /** @type {LocalizedString} */ ("Añadir al calendario VEKN")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Adicionar ao calendário VEKN")
	if (locale === "it") return /** @type {LocalizedString} */ ("Aggiungi al calendario VEKN")
	return /** @type {LocalizedString} */ ("Add to the VEKN calendar")
});